import React, { Component } from 'react';
import "./title.css";

class Title extends Component {
    render() {
      return (
        <div className="title">
            <h1>{this.props.name}</h1>
            <p>{this.props.content || 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'}</p>
        </div>
      );
    }
  }

  export default Title;


// WEBPACK FOOTER //
// ./src/components/title/title.js